const Checkbox = (props: {
    label: string;
    checkHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checkboxType: string
}) => {
    return (
        <div className="checkbox-container">
            <label htmlFor={`checkbox-${props.checkboxType}`} className="checkbox-group">
                {props.label}
                <input
                    type="checkbox"
                    id={`checkbox-${props.checkboxType}`}
                    onChange={props.checkHandler}
                />
                <span className="checkmark" />
            </label>
        </div>
    );
};

export default Checkbox;
